import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => {
	return {
		MainHeaderButtonsWrapper: {
			flex: "none",
			marginLeft: "auto",
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-end",
			flexWrap: "wrap",
			gap: theme.spacing(1),
			minWidth: 0,
			"& > *": {
				margin: 0,
			},
			"& > .MuiTextField-root, & > .MuiFormControl-root": {
				maxWidth: "100%",
			},
			[theme.breakpoints.down("xs")]: {
				width: "100%",
				marginLeft: 0,
				justifyContent: "flex-start",
				"& > .MuiTextField-root, & > .MuiFormControl-root": {
					flex: "1 1 180px",
				},
			},
		},
	};
});

/**
 * Grupo de ações à direita do MainHeader. Mantém os controles alinhados e
 * permite quebra fluida em telas menores.
 */
const MainHeaderButtonsWrapper = ({ children, className }) => {
	const classes = useStyles();

	return (
		<div
			className={[classes.MainHeaderButtonsWrapper, "kp-page-header-actions", className]
				.filter(Boolean)
				.join(" ")}
		>
			{children}
		</div>
	);
};

export default MainHeaderButtonsWrapper;
